import React from 'react'
import { Slot } from 'radix-ui'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useModals } from '@/shared/lib/modal-manager'

export function RenamePricingCampaign({
	children,
}: {
	pricingCampaignId: string
	children: React.ReactNode
}) {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const formContext = useFormContext()
	const handleRename = () =>
		showModal('GENERIC_RENAME_MODAL', {
			title: t('app.edit_pc_name', {
				defaultValue: 'Edit pricing campaign name',
			}),
			value: formContext?.getValues('name'),
			onChange: (value: string) =>
				formContext?.setValue('name', value, {
					shouldDirty: true,
				}),
		})

	return <Slot.Root onClick={handleRename}>{children}</Slot.Root>
}
